import React, { FC } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { Button } from "@mui/material";

type Props = {
  disabled: boolean;
  onClick: () => void;
  width: number;
  height: number;
  fontSize: number;
  icon: any;
  label: string;
  backgroundColor?: string; // 追加
  color?: string; // 追加
};

export const WithIconButton: FC<Props> = (props) => {
  const {
    disabled,
    onClick,
    width,
    height,
    fontSize,
    icon,
    label,
    backgroundColor,
    color,
  } = props;
  const theme = useTheme();

  const getStyles = () => {
    if (disabled) {
      return {
        backgroundColor: "#ccc", // グレー
        color: "#888", // テキスト色も薄めに
        fontSize,
        height,
        width,
        boxShadow: "none", // 無効時はシャドウなし
        cursor: "not-allowed", // カーソルを変更
      };
    }

    return {
      backgroundColor: backgroundColor || theme.palette.foreColor.main,
      color: color || "#000",
      fontSize,
      height,
      width,
      boxShadow: "3px 3px 8px 1px #202226",
      transition: "all 0.3s",
      "&:hover": {
        backgroundColor: backgroundColor
          ? `${backgroundColor}aa`
          : theme.palette.foreColor.light,
        color: color || "#37393F",
        boxShadow: "none",
        transform: "translate(3px, 3px)",
      },
    };
  };

  return (
    <Button
      component="label"
      startIcon={icon}
      disabled={disabled}
      onClick={onClick}
      sx={getStyles()}
    >
      {label}
    </Button>
  );
};
